import httpService from '@Utils/httpService';

const baseUrl = 'api/dashboard/AnomalyInsights';

export default {
    get(params, requestOptions = {}) {
        return httpService.post({
            ...requestOptions,
            url: `${baseUrl}/TypeHeadTemp`,
            data: params,
        });
    },
    /** Accepted findings grouped by AVA Inspect tag, a page of groups (same query body as get). */
    getAvaInspectGroups(params, requestOptions = {}) {
        return httpService.post({
            ...requestOptions,
            url: `${baseUrl}/avaInspectGroups`,
            data: params,
        });
    },
    getFilters(params, requestOptions = {}) {
        return httpService.get({
            ...requestOptions,
            url: `${baseUrl}/filters`,
            params
        });
    },
    update(data) {
        return httpService.put({
            url: `${baseUrl}/${data.id}`,
            data,
        });
    },
    updateComponent(id, data) {
        return httpService.put({
            url: `${baseUrl}/${id}/component`,
            data,
        });
    },
    updatePosition(id, data) {
        return httpService.put({
            url: `${baseUrl}/${id}/position`,
            data,
        });
    },
    updateMultiple(data) {
        return httpService.put({
            url: `${baseUrl}/updateMultiple`,
            data,
        });
    },
    accept(id) {
        return httpService.post({
            url: `${baseUrl}/accept/${id}`,
        });
    },
    reject(id) {
        return httpService.post({
            url: `${baseUrl}/reject/${id}`,
        });
    },
    delete(id) {
        return httpService.delete({
            url: `${baseUrl}/${id}`,
        });
    },
    deleteMultiple(data) {
        return httpService.delete({
            url: `${baseUrl}/deleteMultiple`,
            data,
        });
    },
    getProcessingCount(facilityId) {
        return httpService.get({
            url: `${baseUrl}/processingCount/${facilityId}`,
            timeout: 20000,
        });
    },
    generateReport(id) {
        return httpService.get({
            url: `${baseUrl}/report/${id}`,
        });
    },
    /** Generates the report of an AVA Inspect finding and files it in the tag's documents: { report, document }. */
    saveReportToAvaInspectDocuments(id) {
        return httpService.post({
            url: `${baseUrl}/Report/${id}/ava-inspect-document`,
        });
    },
    /**
     * Generates and files one report containing all findings for an AVA Inspect tag. `documentIds` are tag
     * documents listed in its Referenced documents section, each linked through `documentLinkBase` (the
     * app's facility URL) so the report opens them in Envizion.
     */
    generateAvaInspectionReport(facilityId, tagId, { documentIds = [], documentLinkBase = null } = {}) {
        return httpService.post({
            url: `/api/tags/ava-inspect/${encodeURIComponent(tagId)}/report`,
            data: { documentIds, documentLinkBase },
            headers: facilityId ? { 'X-Facility-Id': facilityId } : {},
        });
    },
    /**
     * The latest inspection report of each of `tagIds` that has one:
     * [{ tagId, documentId, title, createDate, reportUrl }] (tags without a report are left out).
     */
    latestAvaInspectionReports(facilityId, tagIds) {
        return httpService.post({
            url: '/api/tags/ava-inspect/reports/latest',
            data: { tagIds },
            headers: facilityId ? { 'X-Facility-Id': facilityId } : {},
        });
    },
    /** The AVA Inspect tag's documents the report can reference: [{ id, title, documentNumber, fileName, revision, revisionDate }]. */
    listAvaInspectionReportDocuments(facilityId, tagId) {
        return httpService.get({
            url: `/api/tags/ava-inspect/${encodeURIComponent(tagId)}/report/documents`,
            headers: facilityId ? { 'X-Facility-Id': facilityId } : {},
        });
    },
        getById(id, params) {
        return httpService.get({
            url: `${baseUrl}/${id}`,
            params,
            timeout: 20000,
        });
    },
};
